import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import * as React from "react";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { BankThirdParty } from "./BankThirdParty";
import { BankAccountOwner } from "../../../../../../../Wrap/Constants/Enums/Domain/BankAccountOwner";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { BankAccount } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";

interface IThirdPartyBankAccountGroupState {
    isUsingPaymentOutBankDetail: boolean;
}
interface IThirdPartyBankAccountGroupProps extends React.Props<ThirdPartyBankAccountGroup> {
    bankAccounts: BankAccount[];
    isReview: boolean;
    onRef: (ref) => void;
    onChange: (v: BankAccount[]) => void;
}
export class ThirdPartyBankAccountGroup extends FormComponent<
    IThirdPartyBankAccountGroupProps,
    IThirdPartyBankAccountGroupState
> {
    constructor(props: any) {
        super(props);
        this.state = { isUsingPaymentOutBankDetail: false };
    }
    child: Array<any> = [];

    public render(): JSX.Element {
        const thirdPartyBank = this.findBankAccountByOwnerType(BankAccountOwner.ThirdParty);
        const thirdPartyOutBank = this.findBankAccountByOwnerType(BankAccountOwner.ThirdPartyOut);
        return (
            <>
                {SectionHeader("Bank Detail")}

                <BankThirdParty
                    isReview={this.props.isReview}
                    onRef={(ref) => this.child.push(ref)}
                    data={
                        thirdPartyOutBank ? thirdPartyOutBank : this.getEmptyBankDetails(BankAccountOwner.ThirdPartyOut)
                    }
                    onChange={(v) => {
                        if (this.state.isUsingPaymentOutBankDetail) {
                            this.onSyncBankAccount(v);
                        } else {
                            this.onBankAccountChange(v, BankAccountOwner.ThirdPartyOut);
                        }
                    }}
                    label={"Payments Out"}
                />
                <CheckboxGroup
                    type="block"
                    options={[
                        {
                            label: "Use same details for Payments in",
                            value: this.state.isUsingPaymentOutBankDetail,
                            onChange: (v) => this.onCheckBoxChange(v),
                            disabled: this.props.isReview,
                        },
                    ]}
                />

                <BankThirdParty
                    isReview={this.props.isReview ? true : this.state.isUsingPaymentOutBankDetail}
                    onRef={(ref) => this.child.push(ref)}
                    data={thirdPartyBank ? thirdPartyBank : this.getEmptyBankDetails(BankAccountOwner.ThirdParty)}
                    onChange={(v) => this.onBankAccountChange(v, BankAccountOwner.ThirdParty)}
                    label={"Payments in"}
                />
            </>
        );
    }
    private findBankAccountByOwnerType(ownerType: BankAccountOwner): BankAccount {
        const { bankAccounts } = this.props;
        return bankAccounts.find((x) => x.Owner === ownerType);
    }
    private getEmptyBankDetails(ownerType: BankAccountOwner): BankAccount {
        return {
            AccountNumber: null,
            AccountName: null,
            BankDetails: { Name: null, Address: {} },
            IsDefault: false,
            Owner: ownerType,
        };
    }

    private onBankAccountChange(bankAccount: BankAccount, bankAccountOwner: BankAccountOwner): void {
        const bankAccounts = JSON.parse(
            JSON.stringify(this.props.bankAccounts.filter((x) => x.Owner != bankAccountOwner))
        );
        if (bankAccount != null) {
            bankAccount.Owner = bankAccountOwner;
            bankAccounts.push(bankAccount);
        }
        this.props.onChange(bankAccounts);
    }

    private onCheckBoxChange(v: boolean): void {
        this.setState({ isUsingPaymentOutBankDetail: v });
        const paymentOutBankAccount = this.props.bankAccounts.find((x) => x.Owner == BankAccountOwner.ThirdPartyOut);
        if (paymentOutBankAccount) {
            this.onSyncBankAccount(paymentOutBankAccount);
        }
    }

    private onSyncBankAccount(bankAccount: BankAccount): void {
        const bankAccountIn = { ...bankAccount };
        bankAccount.Owner = BankAccountOwner.ThirdPartyOut;
        bankAccountIn.Owner = BankAccountOwner.ThirdParty;
        const bankAccounts = [bankAccount, bankAccountIn];

        this.props.onChange(bankAccounts);
    }
}
